import { useInvalidateReviews } from '@/entities/review';
import { trpc } from '@/shared/api';
import { useAsyncAction } from '@/shared/lib';

export const useUnhideReview = () => {
  const mutation = trpc.reviewManagement.unhide.useMutation();
  const action = useAsyncAction(mutation.mutateAsync, useInvalidateReviews());
  return { ...action, unhide: action.execute };
};
